import { ProLayoutProps } from '@ant-design/pro-components';

const defaultSettings: ProLayoutProps = {
  layout: 'mix',
  token: {
    bgLayout: '#e6e6e6',
    header: {
      colorBgHeader: '#0e243e',
    },
    sider: {
      colorBgCollapsedButton: '#1890FF',
      colorBgMenuItemSelected: '#1890FF',
      colorMenuBackground: '#0e243e',
      colorTextCollapsedButton: '#fff',
      colorTextCollapsedButtonHover: '#fff',
      colorTextMenu: '#A6ADB4',
      colorTextMenuItemHover: '#fff',
      colorTextMenuSelected: '#fff',
    },
  },
};

export default defaultSettings;
